import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { useEffect, useState } from 'react';
import PdfViewer from '../PdfViewer';
import ReviewInvoiceDataForm from '../../../components/forms/Invoice/ReviewInvoiceDataForm';
import type { Hospital, InvoiceBatch } from '../../../apiTypes';
import { getPayorTypeTerm, PAYOR_TYPE_TERMS, PAYOR_TYPES } from '../../../lib/helper/invoice';
import { Button } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'react-router-dom';
import { INVOICES } from '../../../lib/routing/frontend';

type Step2CardProps = {
  extractedText: string;
  invoiceData: { consultant: {}; payorTypeCode: number; existingInvoiceId?: string | number | boolean };
  setReviewedData: () => {};
  invoiceBatch?: InvoiceBatch;
  reset: () => void;
  debug?: boolean;
  file: string;
  children?: React.ReactNode;
  hospitals?: Hospital[];
  determinedPayorTypeCode?: undefined | number;
  selectedPayorType: undefined | number;
  setSelectedPayorType: (payorTypeCode: number) => void;
};

export function Step2Card({
  extractedText,
  invoiceData,
  setReviewedData,
  reset,
  file,
  debug = false,
  hospitals = [],
  invoiceBatch = undefined,
  selectedPayorType,
  setSelectedPayorType,
  determinedPayorTypeCode = undefined,
}: Step2CardProps) {
  const startScale = Number(localStorage.getItem('pdfScale')) || 0.8;
  const [scale, setScale] = useState(startScale);
  const scaleBy = 0.1;
  useEffect(() => {
    localStorage.setItem('pdfScale', scale.toString());
  }, [scale]);

  const getContent = () => {
    if (invoiceData?.existingInvoiceId !== false) {
      return (
        <div className="text-center">
          <h4>This invoice already exists</h4>
          <div className="row mt-4">
            <div className={'col'}>
              <Alert variant={'info text-center'}>
                {/*This invoice already exists*/}
                <Link to={INVOICES.SINGLE.replace(':id', String(invoiceData?.existingInvoiceId))} className={'btn btn-info ml-2'}>
                  View existing Invoice
                </Link>
              </Alert>
            </div>
          </div>
        </div>
      );
    }
    if (selectedPayorType === undefined) {
      return (
        <div className="text-center">
          <h4>Select the Invoice Payor Type</h4>
          <div className="row mt-4">
            {Object.entries(PAYOR_TYPE_TERMS).map(([key, value]) => (
              <div className={'col'} key={key}>
                {Number(key) === PAYOR_TYPES.PATIENT ? (
                  <Button variant={'outline-info'} onClick={() => setSelectedPayorType(Number(key))}>
                    {' '}
                    <i className="fas fa-file-prescription mr-2" />
                    {value}
                  </Button>
                ) : null}
                {Number(key) === PAYOR_TYPES.HOSPITAL ? (
                  <Button variant={'outline-danger'} onClick={() => setSelectedPayorType(Number(key))}>
                    {' '}
                    <i className="fas fa-file-medical  mr-2" />
                    {value}
                  </Button>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      );
    }
    return (
      <>
        {determinedPayorTypeCode !== undefined && invoiceData?.payorTypeCode !== undefined && invoiceData.payorTypeCode !== determinedPayorTypeCode ? (
          <Alert variant={'danger'} className={'text-center font-weight-bold'}>
            You selected Payor Type: {PAYOR_TYPE_TERMS[invoiceData.payorTypeCode]} but this looks like a {PAYOR_TYPE_TERMS[determinedPayorTypeCode]} invoice -
            please be sure to check.
          </Alert>
        ) : null}
        <ReviewInvoiceDataForm invoiceData={invoiceData} onSubmit={setReviewedData} hospitals={hospitals} invoiceBatch={invoiceBatch} />
      </>
    );
  };

  return (
    <Card className="mb-4">
      <Card.Header className={'h2'}>
        Review {getPayorTypeTerm(invoiceData.payorTypeCode)} Invoice Details{' '}
        <button type={'button'} className="btn btn-secondary float-right" onClick={reset}>
          Start Over
        </button>
      </Card.Header>
      <Card.Body>
        {debug && (
          <Row>
            <Col>
              <p>{extractedText}</p>
              <pre>{JSON.stringify(invoiceData, null, 2)}</pre>
            </Col>
          </Row>
        )}
        <Row>
          <Col className={'col-sm-12 col-xl-4'}>
            <div className="crud__section mb-3">{getContent()}</div>
          </Col>
          <Col className={'col-sm-12 col-xl-8 text-center'}>
            <Row className={'mb-2'}>
              <Col>
                <button type={'button'} className="btn btn-sm btn-outline-dark mr-2 col-md-1" onClick={() => setScale(scale + scaleBy)}>
                  +
                </button>
                <button type={'button'} className="btn btn-sm btn-outline-dark col-md-1" onClick={() => setScale(scale - scaleBy)}>
                  -
                </button>
              </Col>
            </Row>
            <Row>
              <Col>{file && <PdfViewer pdfUrl={file} scale={scale} />}</Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
